import { useAuth } from '@/db/useAuth';
import logger from '@/util/logger';
import { storage } from '@rock/db-admin';
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage';
import { useState } from 'react';

const log = logger('useImageUpload');

export function useImageUpload() {
    const [progress, setProgress] = useState(0);
    const [error, setError] = useState('');
    const { user } = useAuth();

    const uploadImage = async (file: File, storagePath: string) => {
        try {
            const storageRef = ref(storage, storagePath);
            const metadata = {
                contentType: file.type,
                customMetadata: {
                    uploader: user!.uid,
                },
            };
            const uploadTask = uploadBytesResumable(storageRef, file, metadata);

            return new Promise<string>((resolve, reject) => {
                uploadTask.on(
                    'state_changed',
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        setProgress(progress);
                    },
                    (error) => {
                        setError(error.message);
                        reject(error);
                    },
                    async () => {
                        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                        resolve(downloadURL);
                    },
                );
            });
        } catch (err: any) {
            setError('Error uploading image.');
            log.error(`Error uploading image: ${err.message}`, { err });
            throw err;
        }
    };

    return { uploadImage, progress, error };
}
